import Vue from 'vue'
import App from './App.vue'
import VueRouter from "vue-router"
import router from './router'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/icons'

import leftPage from './components/leftPage'
import topPage from './components/topPage'

Vue.component('leftPage', leftPage)//公共左侧
Vue.component('topPage', topPage)//公共头部

// import '@/utils/rem'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(ElementUi)
Vue.use(VueRouter)
Vue.config.productionTip = false

new Vue({
    render: h => h(App),
    router
}).$mount('#app')
